import React from 'react'
import { useLoadSalonData } from '../hooks/useLoadSalonData'

const RescheduleAppointmentPage = () => {
  useLoadSalonData({})

  return <div>RescheduleAppointmentPage</div>
}

export default RescheduleAppointmentPage
